import { render, staticRenderFns } from "./SoRs.vue?vue&type=template&id=0b83c968"
import script from "./SoRs.vue?vue&type=script&lang=js"
export * from "./SoRs.vue?vue&type=script&lang=js"
import style0 from "./SoRs.vue?vue&type=style&index=0&id=0b83c968&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports